export function combineReducers(entities: ReducerRegistry): RootReducer {
  return function rootReducer(currentState: AppState, action: Action): AppState {
    const entitiesNames = Object.keys(entities);
    const newState = {...currentState};

    return entitiesNames.reduce((state: AppState, entityName: keyof AppState) => {
      const reducer = entities[entityName];
      const currentValue = state[entityName];
      const newValue = reducer(currentValue, action);
      return {...state, [entityName]: newValue};
    }, newState);
  };
}
